<template>
  <footer class="footer">
    <div class="max-width">
      <div class="footer__main">
        <div class="footer__sub">
          <div class="footer__sub-label">Be the First to Know</div>
          <div class="footer__sub-note">Get early access to our newest Shopify themes, feature releases, and updates, plus practical how-to guides to help you get more from your store — directly to your inbox.</div>

          <SubformView/>
        </div>

        <div class="footer__action">
          <div class="footer__nav">
            <div class="footer__column">
              <div class="footer__label">Sitemap</div>
              <div class="footer__menu">
                <router-link to="/themes">Themes</router-link>
                <router-link to="/contacts">Contacts</router-link>
                <router-link to="/help-center">Help Center</router-link>
              </div>
            </div>
            <div class="footer__column">
              <div class="footer__label">Legal</div>
              <div class="footer__menu">
                <router-link to="/privacy">Privacy Policy</router-link>
                <router-link to="/terms">Terms & Conditions</router-link>
              </div>
            </div>
          </div>

          <div class="footer__copy">almost perfect © All Rights Reserved.</div>
        </div>
      </div>

      <div class="footer__bottom">
        <div class="footer__top js--top">
          <IconUp />
        </div>
        <div class="footer__logo"><img src="@/assets/imgs/logo-footer.svg" alt="Almost Perfect Studio"></div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss">
  .footer {
    background:var(--color-main);

    &__main {
      padding:3rem 0 1rem;
      display:flex;
      justify-content:space-between;
      gap:2rem;

      @include md {
        flex-direction:column;
        padding:3rem 0 1rem;
        gap:3rem;
      }
    }

    &__sub {
      max-width:508px;

      &-label {
        margin:0 0 1rem;
        font-weight: 500;
        font-size: 1rem;
        color:#fff;
        line-height: 1.38;
      }

      &-note {
        font-size:.875rem;
        font-weight:500;
        line-height:1.4;
        color:#fff;
        opacity:.7;
        margin:0 0 1.5rem;
        max-width:450px;
      }
    }

    &__action {
      display:flex;
      flex-direction:column;
    }

    &__nav {
      display:flex;
      color:#fff;
      gap:4.75rem;

      @include md {
        gap:3rem;
      }
    }

    &__column {
      width:max-content;
    }

    &__label {
      margin:0 0 1rem;
      font-size:.875rem;
      font-weight:600;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color:#838383;
    }

    &__menu {
      display:flex;
      flex-direction:column;
      align-items:flex-start;
      gap:.5rem;

      a {
        color:#fff;
        display:table;
        border-bottom:1px solid transparent;

        &:hover, &.router-link-active {
          border-color:#fff;
        }
      }
    }

    &__bottom {
      padding:0 0 2.5rem;
      display:flex;
      align-items:center;
      flex-direction:column;
      gap:28px;
    }

    &__copy {
      margin:auto 0 0;
      font-size: .875rem;
      color:#838383;
      font-weight: 600;
      letter-spacing: 0.02em;
      text-transform: uppercase;

      @include md {
        margin-top:3rem;
      }

      @include xs {
        font-size:.75rem;
        text-align:left;
      }
    }

    &__top {
      width:2.5rem;
      height:2.5rem;
      display:flex;
      align-items:center;
      justify-content:center;
      cursor:pointer;
      user-select:none;
      border-radius:12px;
      transition:var(--transition);
      background:var(--color-accent);

      svg {
        transition:var(--transition);
      }

      &:hover {
        background:#fff;

        svg {
          filter:brightness(0) invert(0);
          transform:translateY(-3px);
        }
      }
    }
  }
</style>

<script setup>
  import IconUp from '@/components/icons/IconUp.vue'
  import SubformView from '@/components/SubformView.vue'
</script>
